import { objectToQueryString } from './objectToQueryString';

const toUrl = (query) => {
  const {
    protocol, hash, host, pathname, search,
  } = window.location;

  const params = new URLSearchParams(search);
  const preview = params.get('x-craft-preview');
  const token = params.get('token');

  let url = `${protocol}//${host}${pathname}`;
  let previewQuery = '';

  if (preview && token) {
    previewQuery = `x-craft-preview=${preview}&token=${token}`;
  }

  if (query || previewQuery) {
    url += `?${query}${previewQuery}`;
  }

  return `${url}${hash}`;
};

export function updateLocationQuery(data = {}) {
  if (!window.history.pushState) {
    return;
  }

  const query = objectToQueryString(data);
  const url = toUrl(query);

  // Get the current URL from window.location
  const currentUrl = window.location.href;

  // Check if the current URL contains 'search?q='
  if (!currentUrl.includes('search?q=')) {
    window.history.pushState({ path: url }, '', url);
  }
}
